import React, { FC, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';


type Props = {
    flash?: string;
    color?: string;
    backgroundColor?: string;
};


export const Flash: FC<Props> = ({ flash, color, backgroundColor }) => {
    const [open, setOpen] = useState(flash !== '');
    const [called, setCalled] = useState(false);
    const history = useHistory();

    useEffect(() => {
        window.onbeforeunload = () => {
            history.replace(window.location.pathname, {});
        };
        if (open) {
            setTimeout(() => {
                setOpen(false);
            }, 2000);
        };
    }, []);

    useEffect(() => {
        if (open) {
            setTimeout(() => {
                setCalled(!called);
            }, 4000);
        };
    }, []);

    return (
        <>
            {flash ? <div className={open ? "flash fadein" : "flash fadeout"}>{flash}</div> : null}

            <style jsx>{`
                div {
                    display: ${called ? "none" : "box"};
                }
                .flash {
                    position: absolute;
                    top: 103px;
                    left: 0;
                    right: 0;
                    margin: auto;
                    background: ${backgroundColor ?? "#dff0d8"};
                    border: solid 1px ${color ?? "#3c763d"};
                    font-size: 14px;
                    padding: 16px 8px 16px 8px;
                    color: ${color ?? "#3c763d"};
                    text-align: left;
                    font-size: 16px;
                    width: 100%;
                    z-index: 10;
                }
                .fadein {
                    animation: fadein 2s;
                }
                .fadeout {
                    animation: fadeout 2s;
                    animation-fill-mode: forwards;
                }
                @media screen and (max-width: 540px) {
                    .flash {
                        top: 91px;
                        padding: 12px;
                        font-size: 12px;
                    }
                }                 
                @keyframes fadein {
                    0% {
                        opacity: 0;
                    }
                    10% {
                        opacity: 1;
                    }
                }
                @keyframes fadeout {
                    0% {
                        opacity: 1;
                    }
                    30% {
                        opacity: 0;
                        display: none;
                    }
                    100% {
                        opacity: 0;
                        display: none;
                        z-index: -100;
                    }
                }
            `}</style>
        </>
    );
};
